var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "copyrightMessage" }, [
    _vm.webInfo
      ? _c("span", [
          _vm._v(
            _vm._s(_vm.webInfo.record_info) +
              " " +
              _vm._s(_vm.webInfo.copy_right_info)
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }